// extracted by mini-css-extract-plugin
module.exports = {"hidden":"RemoveBgAnimalScreen_hidden__3ryFU"};